import React, { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../img/100BILLION_TECH_name.png';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [serviceDropdownOpen, setServiceDropdownOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const desktopDropdownRef = useRef(null);
    const mobileDropdownRef = useRef(null);

    const isActive = (path) => decodeURIComponent(location.pathname) === path;

    useEffect(() => {
        const header = document.querySelector(".new-header-wrapper-hbt");
        const handleScroll = () => {
            if (header) {
                if (window.scrollY > 0) {
                    header.classList.add("scrolled");
                } else {
                    header.classList.remove("scrolled");
                }
            }
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                serviceDropdownOpen &&
                desktopDropdownRef.current &&
                !desktopDropdownRef.current.contains(event.target) &&
                mobileDropdownRef.current &&
                !mobileDropdownRef.current.contains(event.target)
            ) {
                setServiceDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [serviceDropdownOpen]);

    // Helper for external links
    const openExternal = (url) => {
        window.location.href = url;
    };

    return (
        <>
            {/* Desktop Header */}
            <div className="new-header-desktop">
                <header className="new-header-wrapper-hbt">
                    <div className="new-header-logo-hbt" onClick={() => navigate("/")}>
                        {/* <img src={logo} alt="Logo" /> */}
                    </div>
                    <nav className="new-header-nav-hbt">
                        <span className={`new-header-link-hbt ${isActive("/") ? "active-link-hbt" : ""}`} onClick={() => navigate("/")}>Home</span>
                        <span className="new-header-link-hbt" onClick={() => openExternal("https://100billiontech.com/start-growing-your-business-at-%E2%82%B9999/Month")}>OMS</span>
                        <span className="new-header-link-hbt" onClick={() => openExternal("https://100billiontech.com/about-us")}>About</span>
                        <div className="new-header-dropdown-wrapper-hbt" ref={desktopDropdownRef}>
                            <span className="new-header-link-hbt" onClick={() => setServiceDropdownOpen((prev) => !prev)}>
                                Services <i className={`fa fa-chevron-${serviceDropdownOpen ? "up" : "down"}`}></i>
                            </span>
                            <AnimatePresence>
                                {serviceDropdownOpen && (
                                    <motion.div className="new-header-service-dropdown-hbt" initial={{ opacity: 0, y: -10 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -10 }} transition={{ duration: 0.2 }}>
                                        <div onClick={() => openExternal("https://100billiontech.com/real-estate-website-development-service")}>Real Estate</div>
                                        <div onClick={() => openExternal("https://100billiontech.com/website-development")}>Website Development</div>
                                        <div onClick={() => openExternal("https://100billiontech.com/application-development")}>Application Development</div>
                                        <div onClick={() => openExternal("https://100billiontech.com/get-your-online-store")}>Ecommerce Website</div>
                                        <div onClick={() => openExternal("https://100billiontech.com/digital-marketing")}>Digital Marketing</div>
                                        <div onClick={() => openExternal("https://100billiontech.com/meta-ads")}>Meta Ads</div>
                                        <div onClick={() => openExternal("https://100billiontech.com/google-ads")}>Google Ads</div>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                        <span className="new-header-link-hbt" onClick={() => openExternal("https://100billiontech.com/blog")}>Blog</span>
                        <span className="new-header-link-hbt" onClick={() => openExternal("https://100billiontech.com/contact-us")}>Contact</span>
                    </nav>
                </header>
            </div>

            {/* Mobile Header */}
            <div className="new-header-mobile-hbt">
                <div className="new-header-mobile-header-container-hbt">
                    <div className="new-header-mobile-header-left-hbt" onClick={() => navigate("/")}>
                        {/* <img src={logo} alt="Logo" className="new-header-mobile-logo-hbt" /> */}
                    </div>
                    <div
                        className="unique-hamburger"
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                    >
                        <span className="bar top-bar"></span>
                        <span className="bar middle-bar"></span>
                        <span className="bar bottom-bar"></span>
                    </div>


                </div>

                <AnimatePresence>
                    {mobileMenuOpen && (
                        <>
                            <motion.div className="new-header-mobile-drawer-overlay-hbt" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.3 }} onClick={() => setMobileMenuOpen(false)} />
                            <motion.div className="new-header-mobile-drawer-hbt" initial={{ x: "-100%" }} animate={{ x: 0 }} exit={{ x: "-100%" }} transition={{ duration: 0.3 }}>
                                <div className="new-header-mobile-drawer-header-hbt">
                                    <img src={logo} alt="Logo" onClick={() => { setMobileMenuOpen(false); navigate("/"); }} />
                                    <i className="fa fa-times new-header-mobile-close-drawer-hbt" onClick={() => setMobileMenuOpen(false)}></i>
                                </div>
                                <div className="new-header-mobile-drawer-links-hbt">
                                    <div onClick={() => { navigate("/"); setMobileMenuOpen(false); }}>Home</div>
                                    <div onClick={() => { openExternal("https://100billiontech.com/start-growing-your-business-at-%E2%82%B9999/Month"); setMobileMenuOpen(false); }}>OMS</div>
                                    <div onClick={() => { openExternal("https://100billiontech.com/about-us"); setMobileMenuOpen(false); }}>About</div>
                                    <div className="new-header-mobile-drawer-link-with-dropdown-hbt" ref={mobileDropdownRef}>
                                        <div className="new-header-mobile-drawer-link-main-hbt" onClick={() => setServiceDropdownOpen(prev => !prev)}>
                                            Services <i className={`fa fa-chevron-${serviceDropdownOpen ? "up" : "down"}`}></i>
                                        </div>
                                        <AnimatePresence>
                                            {serviceDropdownOpen && (
                                                <motion.div className="new-header-mobile-drawer-service-dropdown-hbt" initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} transition={{ duration: 0.3 }}>
                                                    <div onClick={() => { openExternal("https://100billiontech.com/real-estate-website-development-service"); setMobileMenuOpen(false); }}>Real Estate</div>
                                                    <div onClick={() => { openExternal("https://100billiontech.com/website-development"); setMobileMenuOpen(false); }}>Website Development</div>
                                                    <div onClick={() => { openExternal("https://100billiontech.com/application-development"); setMobileMenuOpen(false); }}>Application Development</div>
                                                    <div onClick={() => { openExternal("https://100billiontech.com/get-your-online-store"); setMobileMenuOpen(false); }}>Ecommerce Website</div>
                                                    <div onClick={() => { openExternal("https://100billiontech.com/digital-marketing"); setMobileMenuOpen(false); }}>Digital Marketing</div>
                                                    <div onClick={() => { openExternal("https://100billiontech.com/meta-ads"); setMobileMenuOpen(false); }}>Meta Ads</div>
                                                    <div onClick={() => { openExternal("https://100billiontech.com/google-ads"); setMobileMenuOpen(false); }}>Google Ads</div>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </div>
                                    <div onClick={() => { openExternal("https://100billiontech.com/blog"); setMobileMenuOpen(false); }}>Blog</div>
                                    <div onClick={() => { openExternal("https://100billiontech.com/contact-us"); setMobileMenuOpen(false); }}>Contact</div>
                                </div>
                            </motion.div>
                        </>
                    )}
                </AnimatePresence>
            </div>
        </>
    );
};

export default Header;
